import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-css-transition'
import { Auth, API } from 'aws-amplify'
import { createBooking } from '../actions/bookingActions'
import Modal from '../components/Modal'
import BookingPricing from '../components/BookingPricing'
import PersonDetailsBlock from './BookingPersonDetailsBlock'
import Cart from '../components/BookingCart'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import TransitionStyles from '../lib/transitionStyles'
import Spinner from '../components/Spinner'
import Header from '../components/bookingPeopleDetailsPage/Header'
import Footer from '../components/bookingPeopleDetailsPage/Footer'
import BookingReservationCountdown from '../components/bookingPeopleDetailsPage/BookingReservationCountdown'
import Utils from '../lib/utils'
import BookingLib from '../lib/booking'

class BookingPeopleDetailsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking,
      peopleComponents: [],
      countdown: '',
      bookerIsLoggedIn: false,
      validationErrors: [],
      overrideHours: []
    }
    this.updateBooking = this.updateBooking.bind(this)
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
    this.goBack = this.goBack.bind(this)
    this.openPriceModal = this.openPriceModal.bind(this)
    this.renewReservation = this.renewReservation.bind(this)
    this.peopleValid = this.peopleValid.bind(this)
    this.openTermsModal = this.openTermsModal.bind(this)
  }

  async componentWillMount() {
    window.scrollTo(0, 0) // TODO avoid duplication on all pages
  }

  async componentDidMount() {
    await this.checkIfBookerLoggedIn()
    this.refreshPeopleComponentsState()
    this.setOverrideHours()
  }

  componentWillReceiveProps(nextProps) {
    const { skus } = this.props
    if (skus !== nextProps.skus) {
      this.refreshPeopleComponentsState(nextProps)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { validationErrors } = this.state
    if (prevState.validationErrors !== validationErrors)
      this.refreshPeopleComponentsState()
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  async setOverrideHours() {
    const overrideHours = await BookingLib.getOverrides()
    this.setState({ overrideHours })
  }

  personValid = (person) => (person.passType && person.firstName && person.lastName) 
    || person.membership 
    || (person.invite && person.firstName && person.lastName && person.inviteEmail && Utils.validateEmail(person.inviteEmail))

  
    // Used to clear errors on user interaction (after submit press)
    clearErrorByNameAndIndex = (personIndex, name, value ) => {
    const { validationErrors } = this.state

    // if firstName/lastName inputs
    if((name === 'firstName' || name === 'lastName') && validationErrors[personIndex]) {
      validationErrors[personIndex][name] = !value
      this.setState({ validationErrors })
      this.clearValidationErrorMessage()
    }

    // if inviteEmail field
    if(name === 'inviteEmail' && validationErrors[personIndex]) {
      validationErrors[personIndex][name] = !(value && Utils.validateEmail(value))
      this.setState({ validationErrors })
      this.clearValidationErrorMessage()
    }

    // if ageCategory or passType fields
    if (validationErrors[personIndex] && (name === 'passType' || name === 'ageCategory') ) {
      console.log(name)
      validationErrors[personIndex][name] = false
      this.setState({ validationErrors })
      this.clearValidationErrorMessage()
    }

  }

  clearValidationErrorMessage = () => {
    console.log('validation message clear')
    const { validationErrors } = this.state
    const hasErrors = validationErrors.map(person => Object.values(person).filter(item => item)).filter(item => item.length > 0 ).length > 0
    
    this.setState({
      showValidationError: hasErrors
    })
  }

  // Used to validate inputs, onSubmit
  populateErrorsOnSubmit = () => {
    const { booking } = this.state

    const ageCategory = index => {
      if (!booking.people[index]) return true

      return !booking.people[index].invite
        ? !booking.people[index].ageCategory && !booking.people[index].membership
        : false
    }

    const passType = index => {
      if (!booking.people[index]) return true
      
      return !booking.people[index].invite
        ? !booking.people[index].passType && !booking.people[index].membership
        : false
    }

    const validationErrors = []
    for (let i = 0; i < (booking.amountPeople + booking.amountPeopleKids); i += 1) {
      const validationError = {
        firstName: booking.people[i] ? !booking.people[i].firstName : true,
        lastName: booking.people[i] ? !booking.people[i].lastName : true,
        
        ageCategory: ageCategory(i),
        passType: passType(i),
        
        ...(booking.people[i] && booking.people[i].invite ? 
          {inviteEmail: booking.people[i] && booking.people[i].inviteEmail ? !Utils.validateEmail(booking.people[i].inviteEmail) : true}: null )
      }
      validationErrors.push(validationError)
    }
    return validationErrors
  }

  populateErrorsOnSubmitToState = () => {
    this.setState({
      validationErrors: this.populateErrorsOnSubmit()
    })

    // refresh
    this.refreshPeopleComponentsState()
  }

  invitationValid = person => person.invite && person.firstName && person.lastName && person.inviteEmail && Utils.validateEmail(person.inviteEmail)

  // Used to exapand participants blocks who have invalid inputs, on submit
  expandInvalidParticipants() {
    const { state, props } = this
    const { booking } = state


    for (let i = 0; i < (booking.amountPeople + booking.amountPeopleKids); i += 1) {
      if (!booking.people[i] || !this.personValid(booking.people[i])) {
        booking.people[i] = { ...booking.people[i], expanded: true }
      }
      else {
        booking.people[i].expanded = false
      }
    }
    props.createBooking(booking)
    this.refreshPeopleComponentsState()
  }

  refreshPeopleComponentsState(props) {
    const { skus } = props || this.props
    const { booking, bookerIsLoggedIn, validationErrors } = this.state
    const peopleComponents = []
    const totalAmount = (booking.amountPeople + booking.amountPeopleKids)
    const peopleCount = booking && booking.people && booking.people.length || 0
    const componentCount = totalAmount > peopleCount ? totalAmount : peopleCount
    for (let i = 0; i < componentCount; i += 1) {
      peopleComponents.push(
        <PersonDetailsBlock
          key={this.getKey()}
          personIndex={i}
          skus={skus}
          openPriceModal={this.openPriceModal}
          personValid={this.personValid}
          bookerIsLoggedIn={bookerIsLoggedIn}
          personErrors={validationErrors[i]}
          clearErrorByNameAndIndex={this.clearErrorByNameAndIndex}
          populateErrorsOnSubmitToState={this.populateErrorsOnSubmitToState}
        />
      )
    }
    this.setState({ peopleComponents })
  }

  async checkIfBookerLoggedIn() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      this.setState({ bookerIsLoggedIn: !!user, email: user.attributes.email })
    } catch (error) {
      // Do nothing
    }
    return Promise.resolve()
  }

  addAllInvites() {
    const { props, state } = this
    const { booking } = state
    const { people } = booking

    const peopleWithInvites = people.map(person => ({
      ...person,
      ...(person.invite && !person.invite.email) && { invite: { email: person.inviteEmail, note: person.inviteNote || '' } }
    }))

    booking.people = peopleWithInvites
    props.createBooking(booking)
  }

  async updateBooking() {
    const { props, state } = this
    const { booking } = state

    // populate people details errors
    this.populateErrorsOnSubmit()

    if (this.peopleValid()) {
      // add all invites, with valid data and unpressed 'Invite' button
      this.addAllInvites()

      props.createBooking(booking)

      try {
        const user = await Auth.currentAuthenticatedUser()
        if (user) {
          props.history.push('/bookings/payment')
        }
      } catch (e) {
        props.history.push('/bookings/signup')
      }
    } else {
      this.setState({
        ...state,
        showValidationError: true,
        validationErrors: this.populateErrorsOnSubmit()
      })

      // If there is invalid inputs, expand people blocks who has invalid inputs
      this.expandInvalidParticipants()

    }
  }

  peopleValid() {
    const { booking } = this.state
    if (!booking.people) return false

    const validPeople = booking.people.filter(person => this.personValid(person) || this.invitationValid(person))
    return validPeople.length === booking.people.length
  }

  goBack() {
    const { props } = this
    props.history.goBack()
  }

  openPriceModal() {
    const { skus } = this.props
    const closeModal = () =>
      this.setState(prevState => ({ ...prevState, currentModal: null }))

    this.setState({
      currentModal: (
        <Modal size="lg" closeAction={closeModal}>
          <BookingPricing skus={skus} />
        </Modal>
      )
    })
  }

  async renewReservation() {
    const { props } = this
    const { booking } = this.state
    const { uuid } = booking.reservation

    booking.reservation = await API.put('cphill', '/reservations', {
      body: {
        uuid
      }
    })
    props.createBooking(booking)
  }

  openTermsModal(url, title = 'Vilkår og betingelser') {
    const closeModal = () =>
      this.setState(prevState => ({ ...prevState, currentModal: null }))

    this.setState({
      currentModal: (
        <Modal size="lg" closeAction={closeModal}>
          <iframe
            src={url}
            style={{ height: 'calc(100vh - 180px)' }}
            title={title}
          />
        </Modal>
      )
    })
  }

  render() {
    const { skus } = this.props
    const {
      booking,
      peopleComponents,
      currentModal,
      countdown,
      showValidationError,
      overrideHours,
      email
    } = this.state
    const step = booking.invitation ? 2 : 3


    return (
      <>
        {currentModal}

        <BookingBreadcrumb booking={booking} step={step} />

        <div className="container mx-auto px-2 sm:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            <Header skus={skus} openPriceModal={this.openPriceModal} />

            {!booking.invitation && (
              <BookingReservationCountdown
                countdown={countdown}
                reservation={booking.reservation}
                renewReservation={this.renewReservation}
              />
            )}

            {peopleComponents}

            {skus.length > 0 ? (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <Cart skus={skus} overrideHours={overrideHours} openTermsModal={this.openTermsModal} email={email} />
              </CSSTransition>
            ) : (
              <Spinner />
            )}

            {showValidationError && (
              <div className="flex items-center bg-red-lighter text-red text-sm px-4 py-3 mt-6 border-l-4 border-red">
                <div className="py-1">
                  <svg
                    className="fill-current h-6 w-6 text-red mr-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                  </svg>
                </div>
                <div>  
                  <FormattedMessage id='booking.people.validationErrorMessage' defaultMessage='Please fill all required fields!' />
                </div>
              </div>
            )}

            <Footer
              goBack={this.goBack}
              updateBooking={this.updateBooking}
              peopleValid={this.peopleValid}
            />
          </div>
        </div>
      </>
    )
  }
}

BookingPeopleDetailsPage.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object }),
  skus: PropTypes.arrayOf(PropTypes.object)
}

BookingPeopleDetailsPage.defaultProps = {
 booking: {},
 skus: []
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(BookingPeopleDetailsPage)